import { QueryClient, type QueryClientConfig } from "@tanstack/react-query";

/**
 * Builds the application `QueryClient`. Shared defaults factory — the error
 * toast now lives in `useRequest`'s own effect, not a `QueryCache` handler
 * here (see `useRequest.tsx`), so any `QueryClient` in the app can use this.
 */
export const createAppQueryClient = (config?: QueryClientConfig): QueryClient =>
  new QueryClient({
    ...config,
    defaultOptions: {
      ...config?.defaultOptions,
      mutations: {
        // v5 defaults mutations to networkMode "online" (pause while
        // offline, auto-resume on reconnect). "offlineFirst" restores v3's
        // always-fire-immediately behaviour, so a paused order can't resubmit
        // later against a stale quote without reconfirmation.
        networkMode: "offlineFirst",
        ...config?.defaultOptions?.mutations,
      },
    },
  });
